import { ResponsiveMultiselectProvider } from "./responsive-multiselect/responsive-multiselect.provider";

export const ProvidersDeclaration = [
    ResponsiveMultiselectProvider,
];